import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-close\"><path d=\"M.952 10.852c.25.249.659.263.898.024l4.06-4.06 4.03 4.03c.245.245.663.25.907.006a.649.649 0 0 0-.006-.907l-4.03-4.03 4.065-4.065c.239-.24.225-.649-.024-.898-.254-.254-.66-.263-.898-.024L5.889 4.993 1.86.963a.654.654 0 0 0-.912-.01c-.243.243-.234.666.01.91l4.031 4.03-4.06 4.061c-.24.239-.23.644.024.898Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol